import { render } from "./PasswordResetPage.vue?vue&type=template&id=06ade504&scoped=true"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js"

import "./PasswordResetPage.vue?vue&type=style&index=0&id=06ade504&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ade504"]])

export default __exports__